import React from 'react';

import Nav from '../../../components/specific/Navigation';
import { Toaster } from 'react-hot-toast';
import { TitlesTables } from '../../../components/global/Styles/titles';
import LoadingTables from '../../../components/global/LoadingTables';

import {
  ComposedChart,
  PieChart,
  Pie,
  Cell,
  Line,
  BarChart,
  Bar,
  Rectangle,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

const TableDashboard = ({ data }) => {
  const TableItemCardDashboard = ({ data }) => {
    if (data) {
      console.log('data', Object.keys(data).length);
      return (
        <ul className=" grid grid-cols-4 gap-4">
          {Object.keys(data).map((item) => {
            return (
              <li
                key={item}
                className="overflow-hidden rounded-lg border bg-white">
                <div className="sm:p-6 px-4 py-5">
                  <div>
                    <div className="truncate text-sm font-medium text-gray-500">{data[item].CLIENTE_NOMBRE}</div>
                    <div className="mt-1 text-gray-900">🆕 Nuevas: {data[item].Nueva}</div>
                    <div className="mt-1 text-gray-900">👍 Aprobadas: {data[item].Aprobada}</div>
                    <div className="mt-1 text-gray-900">❌ Canceladas: {data[item].Cancelada}</div>
                    <div className="mt-1 text-gray-900">🚫 Rechazadas: {data[item].Rechazada}</div>
                    <div className="mt-1 text-gray-900">✅ Confirmadas: {data[item].Confirmada}</div>
                    <div className="mt-1 text-gray-900">🚧 En ejecución: {data[item].Ejecución}</div>
                    <div className="mt-1 text-gray-900">🏁 Finalizadas: {data[item].Finalizada}</div>
                  </div>
                </div>
              </li>
            );
          })}

          {/* <li className="overflow-hidden rounded-lg border bg-white">
            <div className="sm:p-6 px-4 py-5">
              <div>
                <sampleChart />
              </div>
            </div>
          </li> */}

          {Object.keys(data).length === 1 && (
            <>
              <li>
                <div style={{ width: '300px', height: '300px' }}>
                  <SampleChart />
                </div>
              </li>
              <li>
                <div style={{ width: '300px', height: '300px' }}>
                  <SampleChart2 />
                </div>
              </li>
              <li>
                <div style={{ width: '300px', height: '300px' }}>
                  <SampleChart4 />
                </div>
              </li>
            </>
          )}
        </ul>
      );
    }

    return (
      <ul className=" grid grid-cols-4 gap-4">
        <li className="overflow-hidden rounded-lg border bg-white">
          <div className="sm:p-6 px-4 py-5">
            <div>
              {/* <div className="truncate text-sm font-medium text-gray-500">{data[item].CLIENTE_NOMBRE}</div> */}
              <div className="mt-1 text-gray-900">🆕 Nuevas:0</div>
              <div className="mt-1 text-gray-900">👍 Aprobadas:0</div>
              <div className="mt-1 text-gray-900">❌ Canceladas:0</div>
              <div className="mt-1 text-gray-900">🚫 Rechazadas:0</div>
              <div className="mt-1 text-gray-900">✅ Confirmadas:0</div>
              <div className="mt-1 text-gray-900">🚧 En ejecución:0</div>
              <div className="mt-1 text-gray-900">🏁 Finalizadas:0</div>
            </div>
          </div>
        </li>
      </ul>
    );
  };

  return (
    <>
      <ul className="sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 mx-2 mt-2 grid grid-cols-1 gap-4">
        {Object.keys(data).map((item) => {
          return (
            <li
              key={data[item].data.ANIO + '-' + data[item].data.MES}
              className="overflow-hidden rounded-lg bg-white shadow">
              <div className="sm:p-6 px-4 py-5">
                <div>
                  <div className="truncate text-sm font-medium text-gray-500"> {data[item].data.ANIO + '-' + data[item].data.MES}</div>
                  <TableItemCardDashboard data={data[item].solicitud} />
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </>
  );
};

const SampleChart = () => {
  const data = [
    {
      name: 'MNO-323',
      uv: 590,
      pv: 800,
      amt: 1400,
    },
    {
      name: 'MNO-756',
      uv: 868,
      pv: 967,
      amt: 1506,
    },
    {
      name: 'MNO-789',
      uv: 1397,
      pv: 1098,
      amt: 989,
    },
    {
      name: 'DEF-012',
      uv: 1480,
      pv: 1200,
      amt: 1228,
    },
    {
      name: 'GHI-345',
      uv: 1520,
      pv: 1108,
      amt: 1100,
    },
    {
      name: 'JKL-678',
      uv: 1400,
      pv: 680,
      amt: 1700,
    },
  ];

  return (
    <ResponsiveContainer
      width="100%"
      height="100%">
      <ComposedChart
        width={500}
        height={400}
        data={data}
        margin={{
          top: 20,
          right: 20,
          bottom: 20,
          left: 20,
        }}>
        <CartesianGrid stroke="#f5f5f5" />
        <XAxis
          dataKey="name"
          scale="band"
        />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar
          dataKey="uv"
          barSize={20}
          fill="#413ea0"
        />
        <Line
          type="monotone"
          dataKey="uv"
          stroke="#ff7300"
        />
      </ComposedChart>
    </ResponsiveContainer>
  );
};

const SampleChart2 = () => {
  const data = [
    {
      name: 'Petróleo Crudo',
      uv: 4000,
      pv: 2400,
      amt: 2400,
    },
    {
      name: 'Productos Refinados',
      uv: 3000,
      pv: 1398,
      amt: 2210,
    },
    {
      name: 'Gas Natural',
      uv: 2000,
      pv: 9800,
      amt: 2290,
    },
    {
      name: 'Productos Químicos',
      uv: 2780,
      pv: 3908,
      amt: 2000,
    },
    {
      name: 'Agua y Fluidos Especiales',
      uv: 1890,
      pv: 4800,
      amt: 2181,
    },
    {
      name: 'Equipos y Maquinaria',
      uv: 2390,
      pv: 3800,
      amt: 2500,
    },
    {
      name: 'Tuberías y Materiales de Construcción',
      uv: 3490,
      pv: 4300,
      amt: 2100,
    },
    {
      name: 'Residuos Peligrosos',
      uv: 3200,
      pv: 4100,
      amt: 2300,
    },
    {
      name: 'Insumos Logísticos',
      uv: 2800,
      pv: 3600,
      amt: 2200,
    },
    {
      name: 'Productos de Lubricación y Mantenimiento',
      uv: 3100,
      pv: 4000,
      amt: 2400,
    },
  ];

  return (
    <ResponsiveContainer
      width="100%"
      height="100%">
      <BarChart
        width={500}
        height={300}
        data={data}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar
          dataKey="pv"
          fill="#8884d8"
          activeBar={
            <Rectangle
              fill="pink"
              stroke="blue"
            />
          }
        />
        <Bar
          dataKey="uv"
          fill="#82ca9d"
          activeBar={
            <Rectangle
              fill="gold"
              stroke="purple"
            />
          }
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

const SampleChart3 = () => {
  const data = [
    { name: 'Group A', value: 400 },
    { name: 'Group B', value: 300 },
    { name: 'Group C', value: 300 },
    { name: 'Group D', value: 200 },
  ];
  const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

  return (
    <PieChart
      width={500}
      height={300}>
      {/* <Pie
        data={data}
        cx={120}
        cy={200}
        innerRadius={60}
        outerRadius={80}
        fill="#8884d8"
        paddingAngle={5}
        dataKey="value"
      >
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
        ))}
      </Pie> */}
      <Pie
        data={data}
        // cx={420}
        // cy={200}
        startAngle={180}
        endAngle={0}
        innerRadius={60}
        outerRadius={80}
        fill="#8884d8"
        paddingAngle={5}
        dataKey="value">
        {data.map((entry, index) => (
          <Cell
            key={`cell-${index}`}
            fill={COLORS[index % COLORS.length]}
          />
        ))}
      </Pie>
    </PieChart>
  );
};

const SampleChart4 = () => {
  const data01 = [
    { name: 'Petróleo Crudo', value: 400 },
    { name: 'Productos Refinados', value: 300 },
    { name: 'Gas Natural', value: 300 },
    { name: 'Productos Químicos', value: 200 },
  ];
  const data02 = [
    { name: 'MNO-123', value: 100 },
    { name: 'MNO-456', value: 300 },
    { name: 'MNO-789', value: 100 },
    { name: 'DEF-012', value: 80 },
    { name: 'DEF-345', value: 40 },
    { name: 'DEF-678', value: 30 },
    { name: 'DEF-901', value: 50 },
    { name: 'GHI-234', value: 100 },
    { name: 'GHI-567', value: 200 },
    { name: 'JKL-890', value: 150 },
    { name: 'JKL-123', value: 50 },
  ];

  return (
    <ResponsiveContainer
      width="100%"
      height="100%">
      <PieChart
        width={400}
        height={400}>
        <Tooltip />

        <Pie
          data={data01}
          dataKey="value"
          cx="50%"
          cy="50%"
          outerRadius={60}
          fill="#8884d8"
        />
        <Pie
          data={data02}
          dataKey="value"
          cx="50%"
          cy="50%"
          innerRadius={70}
          outerRadius={90}
          fill="#82ca9d"
          label
        />
      </PieChart>
    </ResponsiveContainer>
  );
};

const ViewDashboard = (props) => {
  const { isLoading, customerData } = props.data;

  const hasData = Object.keys(customerData).length > 0;

  return (
    <div className="flex max-h-screen min-h-screen flex-col overflow-hidden ">
      <Nav />
      <Toaster
        toastOptions={{
          className: 'w-1/2',
        }}
      />
      <div className="flex flex-grow flex-col overflow-hidden ">
        <div className="m-2 flex flex-grow flex-col overflow-hidden   ">
          <div className="flex ">
            {/* <TitlesTables>DASHBOARD</TitlesTables> */}
            <div className="flex-auto"></div>
          </div>

          {isLoading && <LoadingTables />}

          {hasData && <TableDashboard data={customerData} />}
        </div>
      </div>
    </div>
  );
};

export default ViewDashboard;
